import type { BrandManager } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'
import { SHORTCUT_EMPLOYEE_FIELDS } from '@@partner:graphql/shortcuts'

export interface BrandManagerInfoInput {
  id?: GQL_ID
  first_name: string
  last_name: string
  status: number
  phone: string
  email: string
  password?: string
}

export interface SaveBrandManager {
  brandManager: BrandManager
}

export interface SaveBrandManagerVariables {
  brandManagerInfo: BrandManagerInfoInput
  upsert: boolean
}

export const GQL_MUTATION_SAVE_BRAND_MANAGER = gql`
  mutation($brandManagerInfo: BrandManagerInfoInput, $upsert: Boolean) {
    brandManager: updateBrandManager(newData: $brandManagerInfo, upsert: $upsert) {
      ${SHORTCUT_EMPLOYEE_FIELDS}
      email
    }
  }
`

export const useMutateSaveBrandManager = () => {
  return useMutation<SaveBrandManager, SaveBrandManagerVariables>(
    GQL_MUTATION_SAVE_BRAND_MANAGER
  )
}
